import React from 'react'
import "./pageBlog.css";

// import NavPage from "../navPage/NavPage";
import HeaderBlog2 from "../pageBlog/HeaderBlog2";
 import BodyBlog2 from "../pageBlog/BodyBlog2";
import Footer2 from "../footer2/Footer2";

function PageBlog2() {
  return (
    <section>
       {/* <NavPage/> */}
       <HeaderBlog2/>
       <BodyBlog2/>
       <Footer2/>
    </section>
  )
}

export default PageBlog2